import movieTrailer from "movie-trailer";
import React, { useEffect, useState } from "react";
import YouTube from "react-youtube";
import instance from "../axios"; //instance variable is used a`s axios
import "../css/rows.css";

const Row = ({ title, fetchURL, isLargeRow }) => {
  const [movie, setMovie] = useState([]);
  const [trailerURL, setTrailerURL]= useState(""); 
  const base_url = "https://image.tmdb.org/t/p/original/";

  //A snippet of code that runs based on a specific condiiton

  useEffect(() => {
    //if [], run once when the row loads or page loads, and dont run again

    const fetchData = async () => {
      const request = await instance.get(fetchURL);
      setMovie(request.data.results);

      return request;
    };
    fetchData();

    //fetchData will append the instance baseURL with fetchURL from the destructed props
    //Eg: https://api.themoviedb.org/3/discover/tv?api_key=${API_KEY}&with_networks=213
  }, [fetchURL]); //whenever there is a variable pulled inside the useEffect from outside must be included in the state of useEffect otherwise wouldn't re-render the useEffect and will show some other results

  const opts = {
    height: "390",
    width: "100%",
    playerVars: {
      autoplay: 1,
    },
  };

  const movieTrailerHandler = (movie) =>{
    if(trailerURL) {
      setTrailerURL('');
    } else {
      movieTrailer(movie?.name || movie?.original_name || movie?.title || "")
      .then((url) => {
        const urlParams = new URLSearchParams(new URL(url).search);
        setTrailerURL(urlParams.get('v'));
      })
      .catch((error) => console.log(error));
    }
  };

  return (
    <div className="row">
      <h2>{title}</h2>

      <div className="row_posters">
        {movie.map((movie) => {
          return (
            <img
            key={movie.id}
            onClick={() => movieTrailerHandler(movie)}
              className={`row_poster ${isLargeRow && "row_poster_larger"}`}
              src={`${base_url}${
                isLargeRow ? movie.poster_path : movie.backdrop_path
              }`}
              alt={movie.name}
            />
          );
        })}
      </div>
      {trailerURL && <YouTube videoId={trailerURL} opts={opts} />}
    </div>
  );
};

export default Row;
